// extracted by mini-css-extract-plugin
export default {"table":"Table_table__6inWA","table__row":"Table_table__row__FTE2r"};